<template>
    <div class="TQ_center">

        <!-- current version -->
        <div>
            <tq-card class="TQ_padding_8px TQ_margin_8px TQ_direction_ltr" padding="16px" >

                <!-- ios -->
                <div>
                    <div>
                        ios version
                    </div>
                    <input v-model="server_versionInfo_local_c.svi_iosVersion_s" class="TQ_center TQ_padding_4px TQ_margin_4px"/>
                </div>

                <!-- android -->
                <div>
                    <div>
                        android version
                    </div>
                    <input v-model="server_versionInfo_local_c.svi_androidVersion_s" class="TQ_center TQ_padding_4px TQ_margin_4px"/>
                </div>

                <!-- web -->
                <div>
                    <div>
                        web version
                    </div>
                    <input v-model="server_versionInfo_local_c.svi_webVersion_s" class="TQ_center TQ_padding_4px TQ_margin_4px"/>
                </div>

                <!-- update button -->
                <tq-loader-container :p_show-loader_b="updateVersionLoader_b">
                    <tq-btn-approve :popup-text="ass_strings.question_updateQuest"
                                    :system-lang-code="store_system_langCode_ve.val"
                                    :approve-cb="m_updateTqVersion_f" v-if="!obj_equals_fb(server_versionInfo_local_c, server_versionInfo_c)">
                        <div class="TQ_bg_green TQ_padding_8px TQ_margin_16px TQ_borderRadius TQ_box_shadow TQ_clickable">
                            {{ass_strings.oneWord_update[store_system_langCode_ve.val]}}
                        </div>
                    </tq-btn-approve>
                </tq-loader-container>

            </tq-card>
        </div>

        <!-- table -->
        <tq-card class="TQ_padding_8px TQ_margin_8px">

            <div class="TQ_bg_gray4 TQ_margin_16px TQ_border TQ_borderRadius TQ_padding_8px">

                <!-- 1) table-->
                <div >
                    <tq-table
                            class="TQ_bg_white TQ_padding_8px "
                            :rows="server_questsExplore_ac"
                            :system-lang-code="store_system_langCode_ve.val"
                            :display-search="true"
                            p_td-classes_s="TQ_padding_8px"
                            :columns="[
                               {label : ass_strings.twoWords_createdDate[store_system_langCode_ve.val],     field : (row) =>{return format_date_YYYY_MM_DD_hh_mm_fs(row.qex_createdDateTime_n)}},
                               {label : ass_strings.twoWords_questType[store_system_langCode_ve.val],       field : 'qex_questType_e'},
                               {label : ass_strings.twoWords_questId[store_system_langCode_ve.val],         field : 'qex_questId_uid'},
                               {label : ass_strings.oneWord_name[store_system_langCode_ve.val],             field : (questExplore_c) => {return JSON.stringify(questExplore_c.qex_langArr_ae.map((lanCode_e) => {return lanCode_e + '-' +  questExplore_c.qex_name_byLangCode_s[lanCode_e]})) }},
                               {label : ass_strings.twoWords_entryCode[store_system_langCode_ve.val],       field : 'qex_shortKeyPrefixId_s'},
                               {label : ass_strings.twoWords_creatorId[store_system_langCode_ve.val],       field : 'qex_creatorId_uid'},
                               {label : ass_strings.oneWord_languages[store_system_langCode_ve.val],        field : 'qex_langArr_ae'},
                            ]"
                            :p_actions_ao="[
                                {label_byLangCode : ass_strings.oneWord_edit,    action_f : m_clickQuestRow_f,   class : 'TQ_bg_gold'},
                            ]"
                    />

                    <!-- 3) get quests btn -->
                    <hr>
                    <div>
                        <tq-loader-button btn-class="TQ_btn TQ_bg_green"
                                          :text=ass_strings.twoWords_getQuests[store_system_langCode_ve.val]
                                          :show-loader="showBtnLoader"
                                          @clickBtn="m_getQuestsExplore_f()">
                        </tq-loader-button>
                    </div>
                </div>

                <!-- 2) selected quest -->
                <tq-card padding="8px"
                         margin="16px"
                         width="100%"
                         max-width="800px"
                         v-if="selectedQuestExplore">

                    <!-- title -->
                    <div class="TQ_text_bold TQ_text_24px TQ_text_underline">
                        {{selectedQuestExplore.qex_name_byLangCode_s[selectedQuestExplore.cm_qex_getDisplayLang_fe(store_system_langCode_ve.val)]}}
                    </div>
                    <hr>

                    <!-- basic info -->
                    <div>
                        <div class="TQ_text_bold TQ_text_20px"> basic info: </div>
                        <div class=""> {{selectedQuestExplore.qex_questType_e}} </div>
                        <div > {{selectedQuestExplore.qex_questId_uid}} </div>
                        <div>
                            {{selectedQuestExplore.qex_langArr_ae}}
                            <span v-if="selectedQuestBody"> {{selectedQuestBody.qb_langArr_ae}}</span>
                        </div>

                        <!-- main id not equal -->
                        <div v-if="selectedQuestBody && selectedQuestExplore.qex_mainLang_e !== selectedQuestBody.qb_mainLang_e">
                            main lang not equal <br>
                            {{selectedQuestExplore.qex_mainLang_e}}, {{selectedQuestBody.qb_mainLang_e}}
                        </div>

                        <!-- quest id not equal -->
                        <div v-if="selectedQuestBody != null && selectedQuestExplore.qex_questId_uid !== selectedQuestBody.qb_questId_uid"
                             class="TQ_bg_red TQ_padding_8px">
                            quest id - not equal
                        </div>
                    </div>
                    <hr>

                    <!-- actions-->
                    <div v-if="!selectedQuestBody">
                        <ball-pulse-sync-loader color="#2E294E" size="10px"/>
                    </div>
                    <div v-else >

                        <!-- quest basic -->
                        <div class="TQ_border">
                            <div class="TQ_padding_8px TQ_grid_col_auto1fr TQ_maxWidth_450px TQ_center TQ_grid_gap_8px TQ_direction_ltr">

                                <!-- main language -->
                                <div class="TQ_grid_center TQ_align_initial"> main language  </div>
                                <tq-dropdown class="dropdown"
                                             :style-select="true">

                                    <div slot="select" >
                                        {{format_langCode_fs(selectedQuestExplore.qex_mainLang_e)}}
                                    </div>

                                    <div    slot="options"
                                            @click="m_updateQuestMainLang_f(langCode)"
                                            v-for="langCode in selectedQuestExplore.qex_langArr_ae">
                                        {{format_langCode_fs(langCode)}}
                                    </div>
                                </tq-dropdown>

                                <!-- new lang code -->
                                <div class="TQ_grid_center TQ_align_initial"> new language  </div>
                                <div class="TQ_align_initial">
                                    <tq-dropdown class="dropdown TQ_margin_4px"
                                                 :style-select="true">

                                        <div slot="select" >
                                            {{format_langCode_fs(selectedNewLangCode)}}
                                        </div>

                                        <div    slot="options"
                                                @click="selectedNewLangCode = langCode"
                                                v-for="langCode in enum_langCodes">
                                            {{format_langCode_fs(langCode)}}
                                        </div>
                                    </tq-dropdown>
                                    <div class="TQ_btn TQ_margin_4px TQ_bg_green"
                                         v-if="!selectedQuestExplore.qex_langArr_ae.includes(selectedNewLangCode)"
                                         @click="m_addLangCode_f()">
                                        {{ass_strings.oneWord_add[store_system_langCode_ve.val]}}
                                    </div>
                                    <div class="TQ_btn TQ_margin_4px TQ_bg_red"
                                         v-if="selectedQuestExplore.qex_langArr_ae.includes(selectedNewLangCode)"
                                         @click="m_removeLangCode_f()">
                                        {{ass_strings.oneWord_delete[store_system_langCode_ve.val]}}
                                    </div>
                                </div>


                                <!-- creatorId -->
                                <div class="TQ_grid_center TQ_align_initial"> CreatorId </div>
                                <input v-model="selectedQuestExplore.qex_creatorId_uid" class="TQ_padding_8px"/>

                                <!-- creatorId -->
                                <div class="TQ_grid_center TQ_align_initial"> shortKeyPrefixId </div>
                                <input v-model="selectedQuestExplore.qex_shortKeyPrefixId_s" class="TQ_padding_8px TQ_width_20px "/>

                                <!-- active quest -->
                                <span class="TQ_grid_center TQ_text_bold TQ_align_initial TQ_margin_top_4px"> {{ass_strings.twoWords_closedCoronavirus[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch class="TQ_grid_center TQ_margin_top_4px TQ_align_initial" v-model="selectedQuestExplore.qex_metadata_c.qeam_closedQuest_b"/>

                                <!--every month event -->
                                <span class="TQ_grid_center TQ_text_bold TQ_align_initial TQ_margin_top_4px"> {{ass_strings.threeWords_oneMonthEvent[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch class="TQ_grid_center TQ_margin_top_4px TQ_align_initial" v-model="selectedQuestExplore.qex_metadata_c.qexm_oneEventEachMonth_b"/>

                                <!-- guide -->
                                <span class="TQ_grid_center TQ_text_bold TQ_align_initial TQ_margin_top_4px"> Guide </span>
                                <tq-toggle-switch class="TQ_grid_center TQ_margin_top_4px TQ_align_initial" v-model="selectedQuestExplore.qex_metadata_c.qexm_guide_b"/>

                            </div>
                        </div>

                        <!-- quest explore -->
                        <div class="TQ_border TQ_padding_8px">
                            <div class="TQ_text_bold TQ_text_24px TQ_text_underline">{{ass_strings.twoWords_questExplore[store_system_langCode_ve.val]}}</div>

                            <!-- active quest -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_inStore[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestExplore.qex_metadata_c.qexm_active_b"/>
                            </div>

                            <!-- active quest -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_displayMap[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestExplore.qex_metadata_c.qexm_displayStartingLocation_b"/>
                            </div>

                            <!-- with starting date -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_withStartingDate[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestExplore.qex_metadata_c.qexm_playerChooseEvent_b"/>
                            </div>

                            <!-- with starting date -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_defaultApproveTickets[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestExplore.qex_metadata_c.qexm_defaultApproveTickets_b"/>
                            </div>

                            <div class="TQ_margin_8px">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_availableTicketsType[store_system_langCode_ve.val]}} </span>

                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_150px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestExplore.qex_metadata_c.qexm_availableTicketsType_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestExplore.qex_metadata_c.qexm_availableTicketsType_e = availableTicketsType"
                                         v-for="availableTicketsType in enum_availableTicketsTypes_s">
                                        {{availableTicketsType}}
                                    </div>
                                </tq-dropdown>
                            </div>
                        </div>

                        <!-- Quest features -->
                        <div class="TQ_border TQ_padding_8px">
                            <div class="TQ_text_bold TQ_text_24px TQ_text_underline">{{ass_strings.twoWords_gameFeatures[store_system_langCode_ve.val]}}</div>


                            <!-- list missions -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_missionsList[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportListMissions_b"/>
                            </div>

                            <!-- list  last riddles -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_listLastMissions[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportListLastMissions_b"/>
                            </div>

                            <!-- cards missions -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_cardsMissions[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportCardsMissions_b"/>
                            </div>

                            <!-- map missions -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_mapMissions[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportMapMissions_b"/>
                            </div>

                            <!-- map last riddles -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_mapLastMissions[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportMapLastMissions_b"/>
                            </div>

                            <br>

                            <!-- chat -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.oneWord_chat[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_supportChat_b"/>
                            </div>

                            <!-- list missions -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_hideStatus[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_quest_hideTeamsStatus_b"/>
                            </div>

                            <!-- clues codes  -->
                            <div class="TQ_margin_8px TQ_inline TQ_verticalAlignTop">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_hintCodes[store_system_langCode_ve.val]}} </span>
                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{ selectedQuestBody.qb_metadata_c.qbm_quest_hiddenCodesMode_e }}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_quest_hiddenCodesMode_e = supportClueCodeType_n"
                                         v-for="(supportClueCodeType_n, label_s) in enum_supportClueCodeTypes">
                                        {{label_s}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <br>

                            <!-- missions arrangement  -->
                            <div class="">
                                <div class="TQ_text_bold"> {{ass_strings.oneWord_path[store_system_langCode_ve.val]}}</div>
                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_quest_missionsArrangements_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_quest_missionsArrangements_e = arrangeMissionsType"
                                         v-for="arrangeMissionsType in enum_arrangeMissionsType_s">
                                        {{arrangeMissionsType}}
                                    </div>
                                </tq-dropdown>

                            </div>

                            <!-- start btn -->
                            <div class="">
                                <div class="TQ_text_bold">
                                    {{ass_strings.threeWords_startClockType[store_system_langCode_ve.val]}}
                                </div>

                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestExplore.qex_metadata_c.qexm_startClockType_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestExplore.qex_metadata_c.qexm_startClockType_e = mapMissionType_e"
                                         v-for="mapMissionType_e in enum_questEventStartClockTypes_s">
                                        {{mapMissionType_e}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- start btn -->
                            <div class="">
                                <div class="TQ_text_bold"> {{ass_strings.twoWords_questFinish[store_system_langCode_ve.val]}} </div>

                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_quest_finishQuest_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_quest_finishQuest_e = questFinish_e"
                                         v-for="questFinish_e in enum_finishQuest_s">
                                        {{questFinish_e}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- lock types  -->
                            <div class="">
                                <div class="TQ_text_bold"> lock types </div>

                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_missions_locksType_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_missions_locksType_e = questLockType_e"
                                         v-for="questLockType_e in enum_missions_LocksType_s">
                                        {{questLockType_e}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- teams types  -->
                            <div class="">
                                <div class="TQ_text_bold">teams type</div>

                                <tq-dropdown class="TQ_width_100p TQ_maxWidth_350px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_quest_questMode_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_quest_questMode_e = questTeamsType_s"
                                         v-for="questTeamsType_s in enum_questTeamsType_s">
                                        {{questTeamsType_s}}
                                    </div>
                                </tq-dropdown>
                            </div>

                        </div>

                        <!-- mission features-->
                        <div class="TQ_border">
                            <div class="TQ_text_bold TQ_text_24px TQ_text_underline">{{ass_strings.twoWords_missionsFeatures[store_system_langCode_ve.val]}}</div>

                            <!-- map section  -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_mapSection[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_missions_supportMapSection_b"/>
                            </div>
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> Lock Start Clock </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_missions_supportStartLockClock_b"/>
                            </div>

                            <!-- finish section  -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_lastSection[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_missions_supportFinishSection_b"/>
                            </div>
                            <!-- missions points -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_missionsPoints[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_missions_supportMissionsPoints_b"/>
                            </div>
                            <!-- skipable -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.oneWord_Skips[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_missions_supportSkips_b"/>
                            </div>
                            <!-- support clues -->
                            <div class="TQ_margin_8px">
                                <div class="TQ_text_bold"> {{ass_strings.oneWord_hints[store_system_langCode_ve.val]}}</div>
                                <tq-dropdown class="TQ_width_200px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_missions_cluesMode_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_missions_cluesMode_e = clueMode_e"
                                         v-for="clueMode_e in enum_cluesMode_e">
                                        {{clueMode_e}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- show all locks -->
                            <div class="TQ_margin_8px">
                                <div class="TQ_text_bold"> Show All Locks</div>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qmb_missions_showAllLocks_b"/>

                            </div>
                        </div>

                        <!-- map missions features -->
                        <div class="TQ_border TQ_padding_8px" v-if="selectedQuestBody.qb_metadata_c.qbm_quest_supportMapMissions_b">
                            <div class="TQ_text_bold TQ_text_24px TQ_text_underline">{{ass_strings.oneWord_map[store_system_langCode_ve.val]}}</div>

                            <!-- 1) map missions type -->
                            <div class="TQ_margin_8px TQ_inline TQ_verticalAlignMiddle">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_mapType[store_system_langCode_ve.val]}} </span>

                                <tq-dropdown class="TQ_width_300px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_mapMissions_missionsType_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_mapMissions_missionsType_e = mapMissionType"
                                         v-for="mapMissionType in enum_mapMissionsTypes">
                                        {{mapMissionType}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- 2) map type -->
                            <div class="TQ_margin_8px TQ_inline TQ_verticalAlignMiddle">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_mapType[store_system_langCode_ve.val]}} </span>

                                <tq-dropdown class="TQ_width_200px" :style-select="true">

                                    <div slot="select">
                                        {{selectedQuestBody.qb_metadata_c.qbm_mapMissions_mapType2_e}}
                                    </div>

                                    <div slot="options"
                                         @click="selectedQuestBody.qb_metadata_c.qbm_mapMissions_mapType2_e = mapType"
                                         v-for="mapType in enum_mapTypes">
                                        {{mapType}}
                                    </div>
                                </tq-dropdown>
                            </div>

                            <!-- 3) show gps btn -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> show gps btn </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_mapMissions_showGpsBtn_b"/>
                            </div>

                            <!-- 4) show zoom control btn -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> show zoom control </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_mapMissions_showZoomControl_b"/>
                            </div>

                            <!-- 4) show zoom control btn -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold">Right Zoom Btn</span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_mapMissions_rightZoomBtns_b"/>
                            </div>

                        </div>

                        <!-- missions list features-->
                        <div class="TQ_border TQ_padding_8px" v-if="selectedQuestBody.qb_metadata_c.qbm_quest_supportListMissions_b">
                            <div class="TQ_text_bold TQ_text_24px TQ_text_underline">{{ass_strings.twoWords_missionsList[store_system_langCode_ve.val]}}</div>

                            <!-- missions groups -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.twoWords_MissionsGroups[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_listMissions_supportMissionsGroups_b"/>
                            </div>

                            <!-- missions groups levels -->
                            <div class="TQ_margin_8px TQ_inline">
                                <span class="TQ_text_bold"> {{ass_strings.threeWords_MissionsGroupsLevels[store_system_langCode_ve.val]}} </span>
                                <tq-toggle-switch v-model="selectedQuestBody.qb_metadata_c.qbm_listMissions_supportMissionsGroupsLevels_b"/>
                            </div>

                        </div>

                    </div>
                    <hr>

                    <!-- class bottom buttons -->
                    <tq-loader-container :p_show-loader_b="serverLoader_b">

                        <!-- delete quest-->
                        <tq-btn-approve
                                class="TQ_inline"
                                btn-class="TQ_btn TQ_text_bold TQ_bg_red TQ_margin_4px TQ_text_capitalize"
                                :system-lang-code="store_system_langCode_ve.val"
                                :text="ass_strings.oneWord_delete"
                                :popup-text="ass_strings.question_deleteQuest"
                                :approve-cb="() => {m_deleteQuest_f() } ">
                        </tq-btn-approve>

                        <!-- copy quest -->
                        <div class="TQ_bg_gold TQ_padding_8px TQ_inline TQ_clickable TQ_box_shadow" @click="showPopup_copyQuest_vb.val = true">
                            {{ass_strings.oneWord_copy[store_system_langCode_ve.val]}}
                        </div>

                        <!-- duplicate -->
                        <tq-btn-approve
                                class="TQ_inline"
                                btn-class="TQ_btn TQ_text_bold TQ_btn_success TQ_margin_4px TQ_text_capitalize"
                                :system-lang-code="store_system_langCode_ve.val"
                                :text="ass_strings.oneWord_duplicate"
                                :popup-text="ass_strings.question_duplicateQuest"
                                :approve-cb="() => {m_duplicateQuest_f() }">
                        </tq-btn-approve>

                        <!-- SPACE -->
                        <div class="TQ_inline TQ_padding_8px ">
                        </div>

                        <!-- update explore btn-->
                        <tq-btn-approve
                                v-if="makeChange_questExplore && !makeChange_questBody"
                                class="TQ_inline"
                                btn-class="TQ_btn TQ_text_bold TQ_bg_gold TQ_margin_4px TQ_text_capitalize"
                                :system-lang-code="store_system_langCode_ve.val"
                                :text="ass_strings.threeWords_updateQuestExplore"
                                :popup-text="ass_strings.question_updateQuest"
                                :approve-cb="m_updateQuestExplore_f">
                        </tq-btn-approve>

                        <!-- update body -->
                        <tq-btn-approve
                                v-if="makeChange_questBody && !makeChange_questExplore"
                                class="TQ_inline"
                                btn-class="TQ_btn TQ_text_bold TQ_bg_gold TQ_margin_4px TQ_text_capitalize"
                                :system-lang-code="store_system_langCode_ve.val"
                                :text="ass_strings.threeWords_updateQuestBody"
                                :popup-text="ass_strings.question_updateQuest"
                                :approve-cb="m_updateQuestBody_f">
                        </tq-btn-approve>

                        <!-- update body && explore-->
                        <tq-btn-approve
                                v-if="makeChange_questExplore && makeChange_questBody"
                                class="TQ_inline"
                                btn-class="TQ_btn TQ_text_bold TQ_bg_gold TQ_margin_4px TQ_text_capitalize"
                                :system-lang-code="store_system_langCode_ve.val"
                                :text="ass_strings.twoWords_updateBoth"
                                :popup-text="ass_strings.question_updateQuest"
                                :approve-cb="m_updateQuestExploreAndBody_f">
                        </tq-btn-approve>


                    </tq-loader-container>

                </tq-card>

                <!-- loader-->
                <div v-if="actionLoader" class="TQ_center">
                    <ball-pulse-sync-loader color="#2E294E" size="10px"/>
                </div>

            </div>
        </tq-card>

        <!-- copy quest popup -->
        <tq-popup :show="showPopup_copyQuest_vb"  max-width="350px" :show-close-btn="true" padding="16px">

            <div>
                <input placeholder="Quest Id" class="TQ_padding_8px TQ_margin_8px" v-model="showPopup_copyQuest_copiedQuestId_s"/>
                <input placeholder="Quest Type" class="TQ_padding_8px TQ_margin_8px" v-model="showPopup_copyQuest_copiedQuestType_s"/>

                <hr>
                <div class="TQ_grid_col_Auto1frAuto">
                    <div class="TQ_bg_gray4 TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_clickable" @click="showPopup_copyQuest_vb.val=false">{{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}</div>
                    <div></div>
                    <div class="TQ_bg_purple TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_clickable" @click="m_copyQuest_f">{{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}</div>
                </div>
            </div>

        </tq-popup>

        <a id="downloadAnchorElem" style="display:none"></a>
    </div>
</template>

<script>
    import TqCard from "../../components/basic/TqCard";
    import TqTable from "../../components/basic2/TqTable";
    import TqPopup from "../../components/basic/TqPopup";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import TqToggleSwitch from "../../components/basic/TqToggleSwitch";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import TqDropdown from "../../components/basic/TqDropdown";
    import {
        enum_langCodes,
        enum_mapMissionsTypes,
        enum_mapTypes,
        enum_questEventStartClockTypes_s,
        enum_availableTicketsTypes_s,
        enum_cluesMode_e,
        enum_arrangeMissionsType_s, enum_finishQuest_s,
        enum_missions_LocksType_s,
        enum_questMode_s, enum_hiddenCodesTypes
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {obj_map_fo, obj_equals_fb, obj_deepCopy_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import {
        FB_QuestBody,
        FB_QuestExplore,
        FB_ServerCurrentVersion
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {format_date_YYYY_MM_DD_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import TqLoaderContainer from "../../components/basic/TqLoaderContainer";
    import {format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {helper_forEachBlcFieldDo_f} from "../../scripts/S_Helper";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {
        server_duplicateQuest_f,
        server_deleteQuest_f, serverBig_questExplore_once_f,
        serverBig_questsExplore_getAll_f,
        serverBig_questBody_once_fp,
        serverBig_questBody_updateByAdmin_f,
        serverBig_questExplore_updateByAdmin_f, serverBig_questBody_update_f, serverBig_questExplore_update_f
    } from "../../scripts/Server/S_ServerFirestore";
    import {
        serverGlobal_currentVersion_vl_set_f, serverGlobal_currentVersion_update_f
    } from "../../scripts/Server/S_ServerPre";
    import {notification_notify} from "../../scripts/S_Notification";
    export default {
        name: "v_Admin_Manage_Quests",
        components: {
            TqLoaderContainer,
            TqDropdown,
            TqLoaderButton,
            TqToggleSwitch,
            TqBtnApprove,
            TqPopup,
            TqTable,
            TqCard
        },
        data() {
            return {
                ass_strings: ass_strings,

                server_versionInfo_c: {},
                server_versionInfo_local_c: {},

                selectedQuestExplore: null,
                old_selectedQuestExplore_stringify: "",
                selectedQuestBody: null,
                selectedQuestBody_stringify: "",
                actionLoader: false,
                showPopup_copyQuest_vb : {val : false},
                showPopup_copyQuest_copiedQuestId_s : "",
                showPopup_copyQuest_copiedQuestType_s : "",
                serverLoader_b : false,
                updateVersionLoader_b : false,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // import
                selectedNewLangCode: enum_langCodes.hebrew,
                enum_mapMissionsTypes: enum_mapMissionsTypes,
                enum_questEventStartClockTypes_s: enum_questEventStartClockTypes_s,
                enum_availableTicketsTypes_s: enum_availableTicketsTypes_s,
                enum_arrangeMissionsType_s: enum_arrangeMissionsType_s,
                enum_mapTypes: enum_mapTypes,
                enum_cluesMode_e: enum_cluesMode_e,
                enum_finishQuest_s: enum_finishQuest_s,
                enum_questTeamsType_s: enum_questMode_s,
                enum_missions_LocksType_s: enum_missions_LocksType_s,
                enum_langCodes: enum_langCodes,
                enum_supportClueCodeTypes: enum_hiddenCodesTypes,
                format_date_YYYY_MM_DD_hh_mm_fs: format_date_YYYY_MM_DD_hh_mm_fs,
                format_langCode_fs: format_langCode_fs,
                obj_equals_fb: obj_equals_fb,

                server_questsExplore_ac: [],

                showBtnLoader: false,
                showQuestBodyLoader: false,
            }
        },
        methods:{

            m_clickQuestRow_f(row){
                this.selectedQuestExplore = row
                this.old_selectedQuestExplore_stringify = JSON.stringify(row)


                this.showQuestBodyLoader = true
                this.selectedQuestBody = undefined

                serverBig_questBody_once_fp(this.selectedQuestExplore.qex_questType_e, this.selectedQuestExplore.qex_questId_uid, false, false,
                    (questBody_c)=>{
                        this.selectedQuestBody = questBody_c

                        this.selectedQuestBody_stringify = JSON.stringify(questBody_c)
                        this.showQuestBodyLoader = false
                    })
            },
            m_getQuestsExplore_f(){
                this.showBtnLoader = true;
                this.server_questsExplore_ac = [];


                serverBig_questsExplore_getAll_f({cb_f: (questsExplore_ac) => {
                    questsExplore_ac.forEach(questExplore => {
                        this.server_questsExplore_ac.push(questExplore);
                    })

                    this.showBtnLoader = false;
                }})
            },
            m_updateTqVersion_f(){
                serverGlobal_currentVersion_update_f(this.server_versionInfo_local_c, () => {
                    this.server_versionInfo_c = new FB_ServerCurrentVersion(this.server_versionInfo_local_c)
                })
            },

            // language manage
            m_removeLangCode_f(){

                let langCode = this.selectedNewLangCode

                if(this.selectedQuestExplore.qex_langArr_ae.length === 1){
                    console.log('only language')
                    return
                }

                if(this.selectedQuestExplore.qex_mainLang_e === langCode){
                    console.log('main language')
                    return
                }

                this.m_removeLangCode_questExplore_f(langCode);
                this.m_removeLangCode_questBody_f(langCode);

            },
            m_removeLangCode_questExplore_f(langCode){
                let langIndex = this.selectedQuestExplore.qex_langArr_ae.indexOf(langCode)
                if(langIndex < 0){return}
                this.selectedQuestExplore.qex_langArr_ae.splice(langIndex, 1)

            },
            m_removeLangCode_questBody_f(langCode){
                let langIndex = this.selectedQuestBody.qb_langArr_ae.indexOf(langCode)

                if(langIndex < 0){return}

                // 1) remove from langArr
                this.selectedQuestBody.qb_langArr_ae.splice(langIndex, 1)
            },
            m_addLangCode_f(){
                this.m_addLangCode_questExplore_f(this.selectedNewLangCode)
                this.m_addLangCode_questBody_f(this.selectedNewLangCode)
            },
            m_addLangCode_questExplore_f(newLangCode_e){

                let mainLang_e = this.selectedQuestExplore.qex_mainLang_e
                this.selectedQuestExplore.qex_langArr_ae.push(newLangCode_e)

                helper_forEachBlcFieldDo_f(this.selectedQuestExplore, (filed_o, key_s) => {
                    if(key_s !== 'qex_langArr_ae'){
                        filed_o[newLangCode_e] = filed_o[mainLang_e]
                    }
                })


            },
            m_addLangCode_questBody_f(newLangCode_e){

                let mainLang_e = this.selectedQuestBody.qb_mainLang_e
                this.selectedQuestBody.qb_langArr_ae.push(newLangCode_e)


                helper_forEachBlcFieldDo_f(this.selectedQuestBody, (filed_o, key_s) => {
                    if(key_s !== 'qb_langArr_ae'){
                        filed_o[newLangCode_e] = filed_o[mainLang_e]
                    }
                })


            },
            m_updateQuestMainLang_f(langCode_e){

                this.selectedQuestExplore.qex_mainLang_e = langCode_e
                this.selectedQuestBody.qb_mainLang_e = langCode_e

            },

            // actions
            m_updateQuestExplore_f(){

                serverBig_questExplore_updateByAdmin_f(this.selectedQuestExplore,(questExplore_c) => {
                    this.old_selectedQuestExplore_stringify = JSON.stringify(questExplore_c)
                    notification_notify(ass_strings.oneWord_updated)
                })
            },
            m_updateQuestBody_f(){
                serverBig_questBody_updateByAdmin_f(this.selectedQuestBody.qb_questType_e, this.selectedQuestBody.qb_questId_uid, this.selectedQuestBody.qb_metadata_c, this.selectedQuestBody.qb_langArr_ae, this.selectedQuestBody.qb_mainLang_e,
                    (questBody_c) => {
                        this.selectedQuestBody_stringify = JSON.stringify(questBody_c)
                    })
            },
            m_updateQuestExploreAndBody_f(){

                this.serverLoader_b = true;

                serverBig_questExplore_updateByAdmin_f(this.selectedQuestExplore, (questExplore_c) => {
                    this.old_selectedQuestExplore_stringify = JSON.stringify(questExplore_c)

                    serverBig_questBody_updateByAdmin_f(this.selectedQuestBody.qb_questType_e, this.selectedQuestBody.qb_questId_uid, this.selectedQuestBody.qb_metadata_c, this.selectedQuestBody.qb_langArr_ae, this.selectedQuestBody.qb_mainLang_e,
                        (questBody_c) => {
                            this.selectedQuestBody_stringify = JSON.stringify(questBody_c)

                            this.serverLoader_b = false;

                            notification_notify(ass_strings.oneWord_updated)
                        })
                })



                // updateAll_b
                // serverBig_questExplore_update_f(questExplore, cb)
                // serverBig_questBody_update_f(questBody, cb)

            },
            m_deleteQuest_f(){
                this.actionLoader = true

                server_deleteQuest_f(this.selectedQuestExplore.qex_questType_e, this.selectedQuestExplore.qex_questId_uid, this.selectedQuestExplore.qex_creatorId_uid, () =>{
                    this.actionLoader = false
                })
            },
            m_duplicateQuest_f(){
                this.actionLoader = true

                this.selectedQuestExplore.qex_name_byLangCode_s = obj_map_fo(this.selectedQuestExplore.qex_name_byLangCode_s, (name_s) => {
                    return name_s + '(copy)'
                })

                server_duplicateQuest_f(this.selectedQuestExplore, this.selectedQuestBody, this.selectedQuestExplore.qex_creatorId_uid,(newQuestExplore_c) =>{
                    this.server_questsExplore_ac.unshift(newQuestExplore_c)
                    this.actionLoader = false
                })
            },
            m_copyQuest_f(){

                this.showPopup_copyQuest_vb.val = false;
                this.serverLoader_b = true;

                serverBig_questExplore_once_f(this.showPopup_copyQuest_copiedQuestId_s, false, (copiedFromQuestExplore_c) => {

                    copiedFromQuestExplore_c.qex_questId_uid = this.selectedQuestBody.qb_questId_uid
                    copiedFromQuestExplore_c.qex_questType_e = this.selectedQuestBody.qb_questType_e
                    copiedFromQuestExplore_c.qex_createdDateTime_n = this.selectedQuestExplore.qex_createdDateTime_n

                    this.selectedQuestExplore = copiedFromQuestExplore_c

                    this.selectedQuestExplore.qex_name_byLangCode_s = obj_map_fo(this.selectedQuestExplore.qex_name_byLangCode_s, (name) => {return name + " (copy)"})

                    serverBig_questExplore_update_f(new FB_QuestExplore(this.selectedQuestExplore), () => {

                        serverBig_questBody_once_fp(this.showPopup_copyQuest_copiedQuestType_s, this.showPopup_copyQuest_copiedQuestId_s , true, false, (copiedFromQuestBody_c) => {
                            copiedFromQuestBody_c.qb_questId_uid = this.selectedQuestBody.qb_questId_uid
                            copiedFromQuestBody_c.qb_questType_e = this.selectedQuestBody.qb_questType_e
                            this.selectedQuestBody = copiedFromQuestBody_c

                            serverBig_questBody_update_f(new FB_QuestBody(this.selectedQuestBody), ()=> {
                                this.m_updateQuestExploreAndBody_f()
                            })
                        })
                    })
                })


            }

        },
        computed:{
            // availableLangCodes
            makeChange_questExplore(){
                return JSON.stringify(this.selectedQuestExplore) !== this.old_selectedQuestExplore_stringify
            },
            makeChange_questBody(){
                return JSON.stringify(this.selectedQuestBody) !== this.selectedQuestBody_stringify
            }
        },
        mounted(){

            // get server versions
            this.updateVersionLoader_b = true
            serverGlobal_currentVersion_vl_set_f(this.$options.name, (versionInfo_c) => {
                this.server_versionInfo_c = versionInfo_c
                this.server_versionInfo_local_c = new FB_ServerCurrentVersion(obj_deepCopy_f(versionInfo_c))
                this.updateVersionLoader_b = false
            });

            // server_questReviews_get_last3_f("OPEN_MAP", "xZJohZfKpQcc5MaT4WAU", null,
            //     (questReview_ac, lastTimestamp_t) => {
            //
            //         // console.log(questReview_ac)
            //
            //         questReview_ac.forEach(review_c => {
            //
            //             review_c.qr_questId_uid = "uBJFtn9hpzPu8EdDc9FT"
            //             console.log(review_c)
            //             server_submitQuestTqReview_f(review_c, () => {})
            //
            //         })
            //     })


            // var questBody_c = new FB_QuestBody(require('./questBody_c.json'))
            // var questExplore_c = new FB_QuestExplore(require('./questExplore_c.json'))

            // serverBig_questBody_updateByAdmin_f(questBody_c.qb_questType_e, questBody_c.qb_questId_uid, questBody_c.qb_metadata_c, questBody_c.qb_langArr_ae, questBody_c.qb_mainLang_e, () => {})

            // serverBig_questBody_update_f(questBody_c, ()=>{})
            // serverBig_questExplore_updateByAdmin_f(questExplore_c, ()=>{})
            //


        }

    }
</script>

<style scoped>

</style>